import React from 'react';
import { __ } from '@wordpress/i18n';

// Clean stroke outline SVG components that match the top menu style.
const EditorOptionIcon = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
		<circle cx="12" cy="12" r="3" />
		<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
	</svg>
);

const EditorEnhancementIcon = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
		<path d="M12 3l1.912 4.088L18 9l-4.088 1.912L12 15l-1.912-4.088L6 9l4.088-1.912z" />
		<path d="M5 16l.956 2.044L8 19l-2.044.956L5 22l-.956-2.044L2 19l2.044-.956z" />
		<path d="M19 16l.956 2.044L22 19l-2.044.956L19 22l-.956-2.044L16 19l2.044-.956z" />
	</svg>
);

const AssetGenerationIcon = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
		<line x1="16.5" y1="9.4" x2="7.5" y2="4.21" />
		<polygon points="12 22.08 12 12 3 6.92 3 17.08 12 22.08" />
		<polygon points="12 22.08 12 12 21 6.92 21 17.08 12 22.08" />
		<polygon points="12 12 3 6.92 12 1.84 21 6.92 12 12" />
		<line x1="12" y1="22.08" x2="12" y2="12" />
	</svg>
);

const VersionControlIcon = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
		<path d="M21.5 2v6h-6" />
		<path d="M21.34 15.57a10 10 0 1 1-.57-8.38l.73-2.62" />
	</svg>
);

const PerformanceIcon = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
		<path d="M4.5 16.5c-1.5 1.25-2.5 3.5-2.5 3.5s2.25-1 3.5-2.5M12 5c-1.5 1.5-2 3.5-2 5.5 0 2 .5 2.5 1.5 3.5s1.5 1.5 3.5 1.5c2 0 4-.5 5.5-2 1.5-1.5 2-4.5 2-6.5s-2.5-4-4.5-4-5 1-6 2.5zM9 15l-3.5 3.5M15 9l-3.5 3.5" />
	</svg>
);

const IntegrationIcon = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
		<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
		<path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
	</svg>
);

const ThemeFontIcon = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
		<polyline points="4 7 4 4 20 4 20 7" />
		<line x1="9" y1="20" x2="15" y2="20" />
		<line x1="12" y1="4" x2="12" y2="20" />
	</svg>
);

const SiteVisibilityIcon = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
		<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
		<circle cx="12" cy="12" r="3" />
	</svg>
);

const LicenseActivationIcon = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
		<path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
	</svg>
);

const sidebarSections = [
	{
		isHeading: true,
		title: 'Editor'
	},
	{ id: 'editor-option', name: 'Editor Option', icon: <EditorOptionIcon /> },
	{ id: 'editor-enhancement', name: 'Editor Enhancement', icon: <EditorEnhancementIcon /> },
	{
		isHeading: true,
		title: 'Utilities'
	},
	{ id: 'asset-generation', name: 'Asset Generation', icon: <AssetGenerationIcon /> },
	{ id: 'version-control', name: 'Version control', icon: <VersionControlIcon /> },
	{ id: 'performance', name: 'Performance', icon: <PerformanceIcon /> },
	{
		isHeading: true,
		title: 'Preference'
	},
	{ id: 'integration', name: 'Integration', icon: <IntegrationIcon /> },
	{ id: 'theme-font', name: 'Theme Font', icon: <ThemeFontIcon /> },
	{ id: 'site-visibility', name: 'Site Visibility', icon: <SiteVisibilityIcon /> },
	{
		isHeading: true,
		title: 'Licensing'
	},
	{ id: 'license-activation', name: 'License Activation', icon: <LicenseActivationIcon /> },
];

const Sidebar = ({ activeTab, setActiveTab }) => {
	console.log('activetab', activeTab);
	return (
		<div className="sidebar">
			<div className="settings-title">Settings</div>
			<nav>
				{sidebarSections.map((item) => {
					if (item.isHeading) {
						return <div key={item.title} className="section-heading">{item.title}</div>;
					}
					return (
						<div
							key={item.id}
							className={`sidebar-item ${activeTab === item.id ? 'active' : ''}`}
							onClick={() => setActiveTab(item.id)}
							role="button"
							tabIndex={0}
						>
							<span className="icon">{item.icon}</span> {item.name}
						</div>
					);
				})}
			</nav>
		</div>
	);
}

export default Sidebar;